import getCompanyId from '@/composables/get-companyid';
import getLocationId from '@/composables/get-locationid';

export default {
	computed: {
		companyId() {
			return getCompanyId(this.$route);
		},
		locationId() {
			return getLocationId(this.$route);
		}
	}
};
